import { render } from "./Tickets.vue?vue&type=template&id=5b2041f2&scoped=true&ts=true"
import script from "./Tickets.vue?vue&type=script&lang=ts"
export * from "./Tickets.vue?vue&type=script&lang=ts"

import "./Tickets.vue?vue&type=style&index=0&id=5b2041f2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2041f2"]])

export default __exports__